module.exports = __webpack_public_path__ + "img/Farmhouse - Gahinglaj.38c3c749.jpg";